export interface CoverageTooltipData {
  values: string[];
  labels: string[];
  colors: string[];
  lastNoColor?: boolean;
}

export const renderCoverageTooltipHTML = ({ values, labels, colors, lastNoColor }: CoverageTooltipData): string => {
  const getRowHTML = (label: string, value: string, color: string) => {
    return `
     <div class="mb-3">
        <div class="flex items-center gap-2 mb-1">
          <div class="w-3 h-3 rounded-sm" style="background-color: ${color || 'gray'};"></div>
          <span class="text-sm text-gray-700 font-medium">${label || '-'}</span>
        </div>
        <div class="ml-5 text-base font-semibold text-gray-900">
          ${value}
        </div>
      </div>
    `;
  };
  const show3rdLine = labels.length > 3;
  return `
    <div style="opacity:1" class="relative opacity-100">
      <span class="absolute -top-[28px] left-1/2 transform -translate-x-1/2 text-white">▲</span>

      ${getRowHTML(labels[0], values[0], colors[0])}
      ${getRowHTML(labels[1], values[1], colors[1])}
      ${show3rdLine ? getRowHTML(labels[2], values[2], colors[2]) : ''}

      <div class="mb-3">
        <div class="flex items-center gap-2 mb-1">
          <div class="w-3 h-3 ${lastNoColor ? 'border' : ' bg-red-500'} rounded-sm"></div>
          <span class="text-sm text-gray-700 font-medium">${labels[labels.length - 1]}</span>
        </div>
        <div class="ml-5 text-base font-semibold text-gray-900">
          ${values[labels.length - 1]} 
        </div>
      </div>
      
    </div>
  `;
};
